<div *ngIf="!isLoadingComplete" class="centered-content">
    <app-loading-spinner></app-loading-spinner>
</div>

<div class="main-content-container">
    <div class="main-content">
        <app-dashboard-panel-header
            [title]="title"
            [isPreview]="isPreview"
            (onDeleteClicked)="handleDeleteClicked()"
        ></app-dashboard-panel-header>
        <div class="graph-container-wrapper">
            <div #graphContainer class="graph-container">
                <app-channel-graph
                    data-cy="dashboard-trend-graph-tab-graph-preview"
                    style="position: relative; flex: 1;"
                    *ngIf="view != null"
                    (onViewLoaded)="handleTrendGraphLoadingComplete()"
                    [onDataUpdate]="onHistoryUpdated"
                    [view]="view"
                    [width]="graphWidth"
                    [height]="graphHeight"
                    [(displayMinXIndex)]="dateRange.startIndex"
                    [(displayMaxXIndex)]="dateRange.endIndex"
                ></app-channel-graph>
                <div
                    *ngIf="!isAtDefaultZoom()"
                    class="icon-reset"
                    (click)="resetZoom()"
                    style="position: absolute; right: 5px; top: 5px"
                ></div>
            </div>
        </div>
    </div>
</div>
